<div>
	<div class="advisor-filter-section">
		<!-- <div class="each-table-filter-section">
			<span class="each-table-filter-label">Select Business Plan</span>
			<mat-select
			class="each-table-filter-input"
			[(ngModel)]="selected_business_plan"
			(selectionChange)="getPageData()"
			>
			<mat-option [value]="0">All</mat-option>
			<mat-option
			*ngFor="let business_plan of business_plan_list"
			[value]="business_plan.id"
			>{{ business_plan.name }}</mat-option
			>
		</mat-select>
	</div> -->
	<div class="each-table-filter-section">
		<span class="each-table-filter-label">Select Duration</span>
		<mat-select
		class="each-table-filter-input"
		[(ngModel)]="selected_duration"
		(selectionChange)="getPageData()"
		>
		<mat-option [value]="'ytd'">YTD</mat-option>
		<mat-option [value]="'last 1 year'">1 Year</mat-option>
		<mat-option [value]="'last 3 years'">3 Years</mat-option>
		<mat-option [value]="'last 5 years'">5 Years</mat-option>
	</mat-select>
</div>
<div class="each-table-filter-section">
	<span class="each-table-filter-label">Select Product</span>
	<mat-select multiple
	class="each-table-filter-input"
	[(ngModel)]="selected_products"
	(selectionChange)="getPageData()"
	>
	<mat-option
	*ngFor="let product of products_list"
	[value]="product.id"
	>{{ product.name }}</mat-option
	>
</mat-select>
</div>
</div>
<ng-container *ngIf="page_loaded">
	<div class="performance-overview-section">
		<!-- <div class="performance-overview-graph-section">
			<div class="sales-info-section">
				<p class="sales-info-heading">Total Sales</p>
				<p class="sales-info-amount">
					{{APP_CONSTANTS.CURRENCY_SYMBOL}} {{ commonService.abbreviateNumber(page_data["total_sales"]) }}
				</p>
				<div
				class="each-sales-info-section"
				*ngFor="let sale_type of page_data['sale_by_type']"
				>
				<p class="each-sales-info-label">
					{{ sale_type.name }} ({{ commonService.abbreviateNumber(sale_type.count) }})
				</p>
				<p class="each-sales-info-value">
					{{APP_CONSTANTS.CURRENCY_SYMBOL}} {{ commonService.abbreviateNumber(sale_type["value"]) }}
				</p>
			</div>
		</div>
		<div class="sales-info-graph-section">
			<div id="performance-graph"></div>
		</div>
	</div> -->
	<div class="performance-overview-summary-section">
		<!-- <p class="summary-section-heading">Sales</p> -->
		<div class="performance-summary-section">
			<div class="each-performance-summary-section">
				<p class="each-performance-summary-value">{{APP_CONSTANTS.CURRENCY_SYMBOL}} {{ commonService.abbreviateNumber(page_data["total_sales"]) }}</p>
				<p class="each-performance-summary-label">Total Sales</p>
			</div>
			<div class="each-performance-summary-section" *ngFor="let sale_type of page_data['sale_by_type']">
				<p class="each-performance-summary-value">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(sale_type["value"]) }}</p>
				<p class="each-performance-summary-label">{{ sale_type.name }} ({{ commonService.abbreviateNumber(sale_type.count) }})</p>
			</div>
		</div>

		<div class="performance-summary-section">
			<div class="each-performance-summary-sub-section" *ngFor="let sale_type of page_data['sales_by_sale_type']">
				<div class="summary-section-heading-section">
					<span class="summary-section-heading">
						{{sale_type.name}}
						<span class="each-performance-summary-label">({{commonService.abbreviateNumber(sale_type.count)}})</span>
					</span>
					<span class="summary-section-heading-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{commonService.abbreviateNumber(sale_type.value)}}</span>
				</div>
				<div class="each-performance-summary-sub-details-section" *ngFor="let data of sale_type['data']">
					<p class="each-performance-summary-value">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(data["value"]) }}</p>
					<p class="each-performance-summary-label">{{ data.name }}({{commonService.abbreviateNumber(data.count)}})</p>
				</div>
			</div>
			<!-- <div class="each-performance-summary-sub-section">
				<p class="summary-section-heading">By AFA</p>
				<p class="summary-section-heading">By Junior Advisor</p>
				<div class="each-performance-summary-sub-details-section" *ngFor="let sale_type of page_data['sale_by_type']">
					<p class="each-performance-summary-value">{{APP_CONSTANTS.CURRENCY_SYMBOL}} {{ commonService.abbreviateNumber(sale_type["value"]) }}</p>
					<p class="each-performance-summary-label">{{ sale_type.name }} ({{ commonService.abbreviateNumber(sale_type.count) }})</p>
				</div>
			</div>
			<div class="each-performance-summary-sub-section">
				<p class="summary-section-heading">By AI</p>
				<div class="each-performance-summary-sub-details-section" *ngFor="let sale_type of page_data['sale_by_type']">
					<p class="each-performance-summary-value">{{APP_CONSTANTS.CURRENCY_SYMBOL}} {{ commonService.abbreviateNumber(sale_type["value"]) }}</p>
					<p class="each-performance-summary-label">{{ sale_type.name }} ({{ commonService.abbreviateNumber(sale_type.count) }})</p>
				</div>
			</div> -->
		</div>
	</div>
	<div class="performance-overview-products-section">
		<p class="performance-overview-products-heading">Products Sold</p>
		<div class="performance-overview-products-content-section">
			<div
			class="each-product-section"
			*ngFor="let product_group of page_data['clients_by_productgroup']"
			>
			<div class="each-product-heading-section">
				<span class="each-product-heading-label">{{
					product_group.name
				}}</span>
				<span class="each-product-heading-count">{{
					commonService.abbreviateNumber(product_group.value)
				}}</span>
			</div>
			<div
			class="each-individual-product-section"
			*ngFor="let product of product_group.products"
			>
			<span class="each-individual-product-label">{{
				product.name
			}}</span>
			<span class="each-individual-product-count">{{
				commonService.abbreviateNumber(product.value)
			}}</span>
		</div>
	</div>
</div>
</div>
</div>
<div class="advisor-graphs-sections">
	<div class="each-advisor-graph-heading-section">
		<mat-checkbox
		[(ngModel)]="show_planned_actual_graphs"
		(change)="createPlannedActualGraphs()"
		>Planned vs Actual</mat-checkbox
		>
	</div>
	<div class="each-advisor-graph-heading-section">
		<mat-checkbox
		[(ngModel)]="show_duration_graphs"
		(change)="createDurationGraphs()"
		>By Duration</mat-checkbox
		>
	</div>
	<div class="each-advisor-graph-heading-section">
		<mat-checkbox
		[(ngModel)]="show_product_graphs"
		(change)="createProductGraphs()"
		>By Products</mat-checkbox
		>
	</div>
	<div class="each-advisor-graph-heading-section">
		<mat-checkbox
		[(ngModel)]="show_customer_graphs"
		(change)="createCustomerGraphs()"
		>By Customer</mat-checkbox
		>
	</div>
	<div class="each-advisor-graph-heading-section">
		<mat-checkbox
		[(ngModel)]="show_region_graphs"
		(change)="createRegionGraphs()"
		>By Region</mat-checkbox
		>
	</div>
</div>
<div class="optimize-charts-section ">
	<div *ngIf="show_planned_actual_graphs">
		<p class="each-optimize-chart-heading gap-between">Planned Vs Actual</p>
		<div class="each-optimize-chart-section">
			<div
			class="each-dashboard-graph-block"
			style="width: calc(100% - 16px)"
			>
			<div class="portfolio-inner-heading-section">
				<img
				src="assets/events.png"
				class="portfolio-section-icon"
				/>
				<span>Planned vs Actual</span>
			</div>
			<div class="each-dashboard-graph-content">
				<div id="planned-actual-graph"></div>
			</div>
		</div>
	</div>
</div>
<div *ngIf="show_duration_graphs">
	<p class="each-optimize-chart-heading gap-between">By Duration</p>
	<div class="each-optimize-chart-section">
		<div class="each-dashboard-graph-block-3" [ngClass]="{'selected-duration-graph': selected_duration != 'ytd' && selected_duration != 'last 1 year'}">
			<div class="portfolio-inner-heading-section">
				<img
				src="assets/events.png"
				class="portfolio-section-icon"
				/>
				<span>Monthly Sales Amount</span>
			</div>
			<div class="each-dashboard-graph-content">
				<div id="monthly-sales-amount-graph"></div>
			</div>
		</div>
		<div class="each-dashboard-graph-block-3" *ngIf="selected_duration == 'ytd' || selected_duration == 'last 1 year'">
			<div class="portfolio-inner-heading-section">
				<img
				src="assets/events.png"
				class="portfolio-section-icon"
				/>
				<span>Quarterly Sales Count</span>
			</div>
			<div class="each-dashboard-graph-content">
				<div id="quarterly-sales-amount-graph"></div>
			</div>
		</div>
		<div class="each-dashboard-graph-block-3">
			<div class="portfolio-inner-heading-section">
				<img
				src="assets/events.png"
				class="portfolio-section-icon"
				/>
				<span>Yearly Sales Amount</span>
			</div>
			<div class="each-dashboard-graph-content">
				<div id="yearly-sales-amount-graph"></div>
			</div>
		</div>
	</div>
</div>
<div *ngIf="show_product_graphs">
	<p class="each-optimize-chart-heading gap-between">By Product</p>
	<div class="each-optimize-chart-section">
		<div class="each-dashboard-graph-block-3">
			<div class="portfolio-inner-heading-section">
				<img
				src="assets/events.png"
				class="portfolio-section-icon"
				/>
				<span>Product Group</span>
			</div>
			<div class="each-dashboard-graph-content">
				<div id="product-group-graph"></div>
			</div>
		</div>
		<div class="each-dashboard-graph-block-3">
			<div class="portfolio-inner-heading-section">
				<img
				src="assets/events.png"
				class="portfolio-section-icon"
				/>
				<span>Product</span>
			</div>
			<div class="each-dashboard-graph-content">
				<div id="product-graph"></div>
			</div>
		</div>
		<div class="each-dashboard-graph-block-3">
			<div class="portfolio-inner-heading-section">
				<img
				src="assets/events.png"
				class="portfolio-section-icon"
				/>
				<span>Product Trends</span>
			</div>
			<div class="each-dashboard-graph-content">
				<div id="product-trends-graph"></div>
			</div>
		</div>
	</div>
</div>
<div *ngIf="show_customer_graphs">
	<p class="each-optimize-chart-heading gap-between">By Customer</p>
	<div class="each-optimize-chart-section">
	  <div class="each-dashboard-graph-block-3">
		<div class="portfolio-inner-heading-section">
		  <img
			src="assets/events.png"
			class="portfolio-section-icon"
		  />
		  <span>Financial Segment</span>
		</div>
		<div class="each-dashboard-graph-content">
		  <div id="financial-segment-graph"></div>
		</div>
	  </div>
	  <div class="each-dashboard-graph-block-3">
		<div class="portfolio-inner-heading-section">
		  <img
			src="assets/events.png"
			class="portfolio-section-icon"
		  />
		  <span>Demographic Segment</span>
		</div>
		<div class="each-dashboard-graph-content">
		  <div id="demographic-group-graph"></div>
		</div>
	  </div>
	  <div class="each-dashboard-graph-block-3">
		<div class="portfolio-inner-heading-section">
		  <img
			src="assets/events.png"
			class="portfolio-section-icon"
		  />
		  <span>AUM</span>
		</div>
		<div class="each-dashboard-graph-content">
		  <div id="customer-aum-graph"></div>
		</div>
	  </div>
	</div>
  </div>
</div>
<div *ngIf="show_region_graphs">
	<p class="each-optimize-chart-heading gap-between">By Region</p>
	<div class="each-optimize-chart-section">
		<div
		class="each-dashboard-graph-block">
		<div class="portfolio-inner-heading-section">
			<img
			src="assets/events.png"
			class="portfolio-section-icon"
			/>
			<span>Sales</span>
		</div>
		<div class="each-dashboard-graph-content">
			<div id="region-sales-graph"></div>
		</div>
	</div>
	<div
	class="each-dashboard-graph-block">
	<div class="portfolio-inner-heading-section">
		<img
		src="assets/events.png"
		class="portfolio-section-icon"
		/>
		<span>Products</span>
	</div>
	<div class="each-dashboard-graph-content">
		<div id="products-sales-graph"></div>
	</div>
</div>
</div>
</div>
</ng-container>
</div>
<div *ngIf="!page_loaded">
	<!-- <div class="ring">
		Loading
		<span></span>
	</div> -->
	<app-loader [loading_text]="'Loading Sales Trends'"></app-loader>
</div>
